export default __webpack_public_path__ + "static/media/twitter.4c626da7.png";